import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { UserSettings } from './user-settings';
import { Settings } from '../core';

@Injectable()
export class UserSettingsStorage {
    constructor(
        private settings: Settings,
        private http: HttpClient
    ) { }

    public async save(userSettings: UserSettings, userPk: number) {
        await this.http
            .post<void>(`${this.settings.apiUrl}/user-settings?editedUserPk=${userPk}`, userSettings)
            .toPromise();
    }
}
